import React from 'react';
import {
  Brand,
  capitalizeFirstLetter,
  createUrl,
  defaultResponseHandler,
  Loading,
  T,
  useAssetTranslation,
} from '@mss/mss-component-library';
import Fetch from '../../util/_fetch';
import { useQueries } from '@tanstack/react-query';

export function BrandsSeries() {
  const { t } = useAssetTranslation();
  const types = ['timeserver', 'firewall', 'router', 'switch'];
  const allQueries = useQueries({
    queries: types.map(type => ({
      queryKey: ['network', 'brands', type],
      queryFn: async () =>
        (
          await defaultResponseHandler<Brand[]>({
            t,
            request: Fetch.get(
              createUrl(
                { assetType: 'network' },
                `brands/?series__type=${type}`,
                true
              )
            ),
          })
        ).data ?? [],
    })),
  });

  const allFetched = allQueries.every(
    query => query.isSuccess && query.data.length > 0
  );

  const sharedClassnames = 'py-2 px-4 border-b border-gray-200 text-sm';
  const thClassnames = `${sharedClassnames} text-left font-medium`;
  const rightThClassnames = `${thClassnames} text-right`;
  const tdClassnames = `${sharedClassnames}`;
  const rightTdClassnames = `${tdClassnames} text-right`;
  if (!allFetched) {
    return <Loading />;
  }

  return (
    <div>
      {allQueries.map((query, index) => {
        const assetSubType = types[index];
        const flattenedData = (
          query.data?.flatMap(brand =>
            brand.series_set.map(model => ({
              brandId: brand.id,
              brandName: brand.name,
              modelId: model.id,
              modelName: model.name,
            }))
          ) ?? []
        ).sort((a, b) => a.brandId - b.brandId);
        return (
          <div key={assetSubType} className="mb-4">
            <h1 className={'text-xl mb-2'}>
              {capitalizeFirstLetter(assetSubType)}
            </h1>
            <table className="min-w-full bg-white border border-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className={rightThClassnames}>
                    <T>Brand ID</T>
                  </th>
                  <th className={thClassnames}>
                    <T>Brand</T>
                  </th>
                  <th className={rightThClassnames}>
                    <T>Series ID</T>
                  </th>
                  <th className={thClassnames}>
                    <T>Model/Series</T>
                  </th>
                </tr>
              </thead>
              <tbody>
                {flattenedData.map((item, i) => (
                  <tr
                    key={`${item.brandId}-${item.modelId}`}
                    className={i % 2 ? 'bg-white' : 'bg-gray-50'}
                  >
                    <td className={rightTdClassnames}>{item.brandId}</td>
                    <td className={tdClassnames}>{item.brandName}</td>
                    <td className={rightTdClassnames}>{item.modelId}</td>
                    <td className={tdClassnames}>{item.modelName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}
